import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import cc from 'classcat';
import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { memo, useEffect, useState } from 'react';
import ThumbsDown from '../icons/ThumbsDown';
import ThumbsUp from '../icons/ThumbsUp';
import css from './UpvoteDownvote.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var VotesMutation = function VotesMutation(_ref) {
  var downvotes = _ref.downvotes,
      executeVote = _ref.executeVote,
      id = _ref.id,
      storageKey = _ref.storageKey,
      upvotes = _ref.upvotes;

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      pastVote = _useState2[0],
      setPastVote = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      voted = _useState4[0],
      setVoted = _useState4[1];

  useEffect(function () {
    var pastVoteStored = Cookies.get(storageKey);
    var voteFromPast = parseInt(pastVoteStored, 10);
    setPastVote(voteFromPast);
    setVoted(voteFromPast);
  }, [storageKey]);

  var vote = function vote(newScore) {
    var undoVote = voted === newScore;
    var score = undoVote ? 0 : newScore;
    var variables = {
      id: id,
      score: score
    };

    if (voted) {
      variables.previousScore = voted;
    }

    if (undoVote) {
      Cookies.remove(storageKey);
    } else {
      Cookies.set(storageKey, score, {
        expires: 30,
        path: '/'
      });
    }

    setVoted(score);
    executeVote(variables);
  };

  var pastUpvote = pastVote === 1;
  var pastDownvote = pastVote === -1; // display logic for shown upvotes/downvotes
  // needed mainly to connect past vote from cookies to votes from query data

  var upvoteAmount = !pastUpvote ? 1 : 0;
  var downvoteAmount = !pastDownvote ? 1 : 0;
  var upvoteRetractAmount = pastUpvote ? 1 : 0;
  var downvoteRetractAmount = pastDownvote ? 1 : 0;
  var upvotesTotal = voted === 1 ? upvotes + upvoteAmount : upvotes - upvoteRetractAmount;
  var downvotesTotal = voted === -1 ? downvotes + downvoteAmount : downvotes - downvoteRetractAmount; // if undoing vote, just show votes from query data
  // but also if past vote exists, decrement that upvote/downvote

  if (voted === 0) {
    upvotesTotal = pastUpvote ? upvotes - 1 : upvotes;
    downvotesTotal = pastDownvote ? downvotes - 1 : downvotes;
  }

  return /*#__PURE__*/_jsxs("div", {
    className: css.root,
    children: [/*#__PURE__*/_jsxs("button", {
      "aria-label": "Click to up vote and mark as helpful",
      className: cc([css.button, css.up, _defineProperty({}, css.voted, upvotesTotal >= 1)]),
      onClick: function onClick() {
        return vote(1);
      },
      type: "button",
      children: [/*#__PURE__*/_jsx(ThumbsUp, {}), "\xA0", upvotesTotal]
    }), /*#__PURE__*/_jsxs("button", {
      "aria-label": "Click to down vote and mark as not helpful",
      className: cc([css.button, css.down, _defineProperty({}, css.voted, downvotesTotal >= 1)]),
      onClick: function onClick() {
        return vote(-1);
      },
      type: "button",
      children: [/*#__PURE__*/_jsx(ThumbsDown, {}), "\xA0", downvotesTotal]
    })]
  });
};

VotesMutation.propTypes = {
  downvotes: PropTypes.number.isRequired,
  executeVote: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  storageKey: PropTypes.string.isRequired,
  upvotes: PropTypes.number.isRequired
};
export default /*#__PURE__*/memo(VotesMutation);